import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

const getSortGlyph = (currentSorter, mySorterId) => {
  if (mySorterId !== currentSorter.id) {
    return null;
  }

  return currentSorter.ascending ? 'up' : 'down';
};

const SortableHeaderComponent = ({
  text,
  currentSorter,
  mySorterId,
  onSorterChange,
  style,
  extraClassNames,
  ...props
}) => (
  <th
    className={`pointer sortable ${extraClassNames || ''}`}
    scope="col"
    onClick={() => onSorterChange({
      id: mySorterId,
      ascending: mySorterId === currentSorter.id ?
        !currentSorter.ascending :
        true
    })}
    style={style}
    {...props}
  >
    {text} <Glyphicon glyph={`arrow-${getSortGlyph(currentSorter, mySorterId)}`} />
  </th>
);

SortableHeaderComponent.propTypes = {
  text: PropTypes.string.isRequired,
  currentSorter: PropTypes.shape({
    id: PropTypes.number.isRequired,
    ascending: PropTypes.bool.isRequired
  }).isRequired,
  mySorterId: PropTypes.number.isRequired,
  onSorterChange: PropTypes.func.isRequired,
  style: PropTypes.object.isRequired,
  extraClassNames: PropTypes.string
};
export default SortableHeaderComponent;


// WEBPACK FOOTER //
// src/Components/SortableHeaderComponent.jsx